import request from '@/utils/request'

let AnchorApi = {
  /*主播列表*/
  anchorlist(data, errorback) {
    return request._post('/shop/plus.anchor.anchor/index', data, errorback);
  },

  /*主播详情*/
  toEditAnchor(data, errorback) {
    return request._get('/shop/plus.anchor.anchor/detail', data, errorback);
  },

  /*修改主播手机号码*/
  editAnchorPhone(data, errorback) {
    return request._post('/shop/plus.anchor.anchor/changePhone', data, errorback);
  },

  /*主播预告列表*/
  anchorNoticeList(data, errorback) {
    return request._post('/shop/plus.anchor.anchor/noticeList', data, errorback);
  },

   /*任务积分列表*/
  anchorCoinList(data, errorback) {
    return request._post('/shop/plus.anchor.anchor/coinList', data, errorback);
  },

  /*审核主播预告*/
  auditNotice(data, errorback) {
    return request._post('/shop/plus.anchor.anchor/auditNotice', data, errorback);
  },
  /*审核积分打卡*/
  auditCoin(data, errorback) {
    return request._post('/shop/plus.anchor.anchor/auditAnchorCoin', data, errorback);
  },
  /*赠送积分*/
  sendCoin(data, errorback) {
    return request._post('/shop/plus.anchor.anchor/sendCoin', data, errorback);
  },
}
export default AnchorApi;



// WEBPACK FOOTER //
// ./src/api/anchor.js